import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../../services/api';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [showPwd,   setShowPwd]   = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [done,      setDone]      = useState(false);
  const [error,     setError]     = useState('');

  if (!token || !email) {
    return (
      <div dir="rtl" className="min-h-screen bg-[#F5F9FF] flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_4px_24px_rgba(30,64,175,.10)] p-8 text-center">
          <div className="text-5xl mb-4">❌</div>
          <h2 className="text-lg font-bold text-gray-800 mb-2">رابط غير صالح</h2>
          <p className="text-sm text-gray-500 mb-6">الرابط مكسور أو منتهي الصلاحية. اطلب رابطاً جديداً.</p>
          <Link to="/forgot-password" className="block w-full text-center bg-[#1E40AF] hover:bg-[#1D4ED8] text-white font-bold py-3 rounded-xl transition-colors">
            طلب رابط جديد
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8)       { setError('كلمة المرور يجب أن تكون 8 أحرف على الأقل'); return; }
    if (password !== confirm)       { setError('كلمتا المرور غير متطابقتين'); return; }
    setLoading(true);
    try {
      await authAPI.resetPassword({ token, email, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err?.response?.data?.message || 'رابط غير صالح أو منتهي الصلاحية');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-[#F5F9FF] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_4px_24px_rgba(30,64,175,.10)] p-8">

        {/* Logo */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1E40AF] text-white text-2xl font-black mb-3">س</div>
          <h1 className="text-xl font-black text-gray-900">تعيين كلمة مرور جديدة</h1>
          <p className="text-sm text-gray-500 mt-1">{email}</p>
        </div>

        {done ? (
          <div className="text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">تم تغيير كلمة المرور</h2>
            <p className="text-sm text-gray-500 mb-6">سيتم تحويلك لصفحة تسجيل الدخول خلال ثوانٍ…</p>
            <Link to="/login" className="block w-full text-center bg-[#1E40AF] hover:bg-[#1D4ED8] text-white font-bold py-3 rounded-xl transition-colors">
              تسجيل الدخول الآن
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">كلمة المرور الجديدة</label>
              <div className="relative">
                <input
                  type={showPwd ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError(''); }}
                  placeholder="8 أحرف على الأقل"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button type="button" onClick={() => setShowPwd(v => !v)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs font-semibold">
                  {showPwd ? 'إخفاء' : 'إظهار'}
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">تأكيد كلمة المرور</label>
              <input
                type={showPwd ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => { setConfirm(e.target.value); setError(''); }}
                placeholder="أعد كتابة كلمة المرور"
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {error && <p className="text-red-600 text-sm font-semibold">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1E40AF] hover:bg-[#1D4ED8] disabled:opacity-60 text-white font-bold py-3 rounded-xl transition-colors"
            >
              {loading ? 'جاري الحفظ...' : 'حفظ كلمة المرور الجديدة'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
